import { useRestaurants } from '@/hooks/useRestaurants';
import { BurgerMenu } from './BurgerMenu';
import { NotificationBell } from './NotificationBell';
import { Store } from 'lucide-react';
import { Logo } from '@/components/common/Logo';

export function Header() {
  const { data: restaurants } = useRestaurants();

  const restaurant = restaurants?.[0];

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-gradient-to-r from-primary/95 via-primary to-primary/95 backdrop-blur supports-[backdrop-filter]:bg-primary/80 shadow-sm">
      <div className="container mx-auto px-3 sm:px-4 lg:px-6">
        <div className="flex h-16 sm:h-16 md:h-16 lg:h-16 items-center justify-between gap-2 sm:gap-4">
          <div className="flex items-center gap-2 sm:gap-3 md:gap-4 min-w-0 flex-1">
            <BurgerMenu />
            <div className="flex items-center gap-3 sm:gap-4 min-w-0">
              <Logo className="h-16 w-16 hidden sm:hidden md:block lg:block  md:h-19 md:w-20 lg:h-[150px] lg:w-[150px] md:mt-0 lg:mt-4" />
            </div>
          </div>

          <div className="flex items-center gap-1 sm:gap-2 flex-shrink-0">
            <NotificationBell />
            {restaurant && (
              <div className="flex items-center gap-1.5 sm:gap-2 text-xs sm:text-sm bg-primary-foreground/10 hover:bg-primary-foreground/20 px-2 sm:px-3 py-1.5 sm:py-2 rounded-lg transition-colors">
                <Store className="w-3 h-3 sm:w-4 sm:h-4 text-primary-foreground flex-shrink-0" />
                <span className="font-medium text-primary-foreground truncate max-w-[100px] sm:max-w-[150px] md:max-w-none">
                  {restaurant.name}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
